'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdReplay5 = function MdReplay5(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.7 22.7c-0.2 0-0.6 0.1-0.6 0.3 0 0.1-0.1 0.2-0.1 0.2h-1.2l0.4-3.7h4v1.2h-2.9l-0.2 1.5s0.2 0 0.2-0.2 0.2 0 0.2-0.2 0.2 0 0.3 0h0.4c0.3 0 0.7 0.1 0.8 0.2s0.5 0.3 0.6 0.5c0.4 0.3 0.7 1.1 0.7 1.8 0 0.3 0 0.7-0.1 0.9s-0.2 0.5-0.6 0.8-0.4 0.3-0.6 0.5-0.7 0.1-1 0.1-0.7 0-0.9-0.1-0.4-0.2-0.7-0.3c-0.5-0.2-0.7-0.9-0.7-1.5h1.3c0 0.6 0.4 0.8 1 0.8 0.2 0 0.3 0 0.5-0.2l0.4-0.3s0.1-0.3 0.1-0.5v-1l-0.1-0.3-0.4-0.4s-0.3-0.1-0.5-0.1h-0.3z m0.3-14.3c7.3 0 13.4 5.9 13.4 13.2s-6.1 13.4-13.4 13.4-13.4-6-13.4-13.4h3.4c0 5.5 4.5 10 10 10s10-4.5 10-10-4.5-10-10-10v6.8l-8.4-8.4 8.4-8.4v6.8z' })
        )
    );
};

exports.default = MdReplay5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/replay-5.js
// module id = 1390
// module chunks = 36573943044255 79611799117203 213534597649335